/**
 * Route for `linear-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinearAttributionPage } from "../features/linear-attribution/LinearAttributionPage";

export const linearAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/linear-attribution",
	component: LinearAttributionPage,
});

export default linearAttributionRoute;
